import Cookies from "js-cookie";
import { logger } from "@tecma/logs-fe";
import { getApolloClient } from "client/apolloClient";

import { IMPERSONATED_CLIENT_COOKIE } from "constants/auth";
import Client from "client/Client";

export const getClient = async (
  projectId: string,
  clientId = Cookies.get(IMPERSONATED_CLIENT_COOKIE) || "",
  client = getApolloClient(),
) => {
  try {
    const clientInfo = await client.query({
      query: Client.GET_CLIENT,
      fetchPolicy: "network-only",
      ...Client.GET_CLIENT_DEFAULT_OPTIONS(projectId, clientId),
    });
    return clientInfo.data?.getClient;
  } catch (err) {
    logger.error(err);
    throw Error();
  }
};
